<script setup lang="ts">
import MainBreadcrumbs from "@/ui/components/header/MainBreadcrumbs.vue";
import { ref } from "vue";

const breadcrumbs = [
	{
		title: "Loyalty",
		disabled: true,
		to: "/pro-loyalty",
	},
];

const activeTab = ref("Overview");

type TabsType = {
	label: string;
	icon: string;
	to: string;
};

const tabs: TabsType[] = [
	{
		label: "Overview",
		icon: "fa-arrow-progress",
		to: "/pro-loyalty/dashboard",
	},
	{
		label: "Scenarios",
		icon: "fa-arrow-progress",
		to: "/pro-loyalty/scenarios",
	},
	{
		label: "Tasks",
		icon: "fa-list-check",
		to: "/pro-loyalty/todos",
	},
	{
		label: "Labels",
		icon: "fa-tags",
		to: "/pro-loyalty/labels",
	},
];
</script>

<template>
	<div>
		<main-breadcrumbs :breadcrumbs="breadcrumbs" />

		<v-tabs v-model="activeTab" class="bg-grey100 rounded-md">
			<v-tab
				v-for="tab in tabs"
				:value="tab.label"
				color="primary"
				:to="tab.label !== activeTab ? tab.to : undefined"
				width="200"
			>
				<i :class="`fa-duotone ${tab.icon} fa-lg`"></i>
				<div class="tab-text">
					{{ tab.label }}
				</div>
			</v-tab>
		</v-tabs>
		<v-divider />

		<router-view />
	</div>
</template>

<style lang="scss"></style>
